import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { Button, Card, Icon, List, Table } from "semantic-ui-react";

import util from "utils/utils";

import { FileChooserWithDropzone } from "components/lib/Choosers";

import { BodySegment } from "./styles";

type FileProps = {
  field: any;
  ideaId: any;
  fieldValue: any;
  updateIdea: any;
  isEditing: boolean;
};

type FileComponentProps = {
  files: Array<{ name: string; value: string }>;
  onRemove?: (fileId: string) => void;
};

export const FileComponent = ({ files, onRemove }: FileComponentProps) => {
  const { t } = useTranslation();

  return (
    <Card.Group centered onClick={(e) => e.stopPropagation()}>
      <Card style={{ width: "80%" }}>
        <Card.Content style={{ color: "#808080" }}>
          <Icon name="file alternate outline" />
          {util.pluralise(files.length, "uploaded file", "uploaded files")}
        </Card.Content>
        <Card.Content textAlign="center">
          <Table basic="very" columns={2}>
            <Table.Body>
              {files.map((file) => (
                <Table.Row key={file.value}>
                  <Table.Cell>
                    <Icon
                      name="file"
                      size="large"
                      style={{ color: "#808080", marginTop: -4 }}
                    />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={file.value}
                      download={file.name}
                      title={file.name}
                    >
                      {file.name}
                    </a>
                  </Table.Cell>
                  <Table.Cell collapsing>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "0.25rem",
                      }}
                    >
                      <Button
                        as="a"
                        target="_blank"
                        rel="noopener noreferrer"
                        basic
                        href={file.value}
                        download={file.name}
                        icon="download"
                        content={t("generic.download")}
                        size="tiny"
                        style={{ marginLeft: 0, marginRight: 0 }}
                      />
                      {onRemove ?
                        <Button
                          basic
                          icon="trash"
                          onClick={(e) => {
                            onRemove(file._id);
                          }}
                          size="tiny"
                          style={{ marginLeft: 0, marginRight: 0 }}
                        />
                      : null}
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
    </Card.Group>
  );
};

const File = ({
  field,
  ideaId,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FileProps) => {
  const { t } = useTranslation();

  if (!isEditing) {
    if (fieldValue) return <FileComponent files={[fieldValue]} />;
    return null;
  }

  if (fieldValue) {
    return (
      <BodySegment>
        <FileComponent
          files={[fieldValue]}
          onRemove={() => updateIdea(null, ["templated", field.id])}
        />
      </BodySegment>
    );
  }

  return (
    <FileChooserWithDropzone
      forType="idea"
      forId={ideaId}
      onComplete={(_, fileName, imageSrc) => {
        updateIdea({ value: imageSrc, name: fileName }, [
          "templated",
          field.id,
        ]);
      }}
      onError={toast.error}
      popupProps={{ position: "bottom center" }}
      dropzoneProps={{
        title: "Upload a file",
        DropZoneComponent: BodySegment,
        defaultIcon: "file",
      }}
    />
  );
};

export default File;
